const orderList = () => import('./orderList');
const gkryOrderDetail = () => import('./orderdetail/gkryOrderDetail');
const trainingOrderDetail = () => import('./orderdetail/trainingOrderDetail');
const jiemoOrderDetail = () => import('./orderdetail/jiemoOrderDetail');
const qcrbOrderDetail = () => import('./orderdetail/qcrbOrderDetail');
const nseriesOrderDetail = () => import('./orderdetail/nseriesOrderDetail');
const payList = () => import('./payList');
const payConfirm = () => import('./payConfirm');
const refundList = () => import('./refundList');
const commissionList = () => import('./commissionList');
const commissionForm = () => import('./commissionForm');

const financeRouter = [
  {
    path: '/finance/orderList', name: 'financeOrderList', component: orderList, meta: { c: 'finance', a: 'orderlist' }
  },
  {
    path: '/finance/gkryOrderDetail/:id', name: 'gkryOrderDetail', component: gkryOrderDetail, meta: { c: 'finance', a: 'gkryorderdetail' }
  },
  {
    path: '/finance/trainingOrderDetail/:id', name: 'trainingOrderDetail', component: trainingOrderDetail, meta: { c: 'finance', a: 'trainingorderdetail' }
  },
  {
    path: '/finance/jiemoOrderDetail/:id', name: 'jiemoOrderDetail', component: jiemoOrderDetail, meta: { c: 'finance', a: 'jiemoOrderDetail' }
  },
  {
    path: '/finance/qcrbOrderDetail/:id', name: 'qcrbOrderDetail', component: qcrbOrderDetail, meta: { c: 'finance', a: 'qcrbOrderDetail' }
  },
  {
    path: '/finance/nseriesOrderDetail/:id', name: 'nseriesOrderDetail', component: nseriesOrderDetail, meta: { c: 'finance', a: 'nseriesOrderDetail' }
  },
  {
    path: '/finance/payList', name: 'financePayList', component: payList, meta: { c: 'finance', a: 'paylist' }
  },
  {
    path: '/finance/payConfirm', name: 'financePayConfirm', component: payConfirm, meta: { c: 'finance', a: 'payconfirm' }
  },
  {
    path: '/finance/refundList', name: 'financeRefundList', component: refundList, meta: { c: 'finance', a: 'refundlist' }
  },
  {
    path: '/finance/commissionList', name: 'financeCommissionList', component: commissionList, meta: { c: 'finance', a: 'commissionList' }
  },
  {
    path: '/finance/commission/add', name: 'financeCommissionAdd', component: commissionForm, meta: { c: 'finance', a: 'commissionAdd' }
  },
  {
    path: '/finance/commission/:id', name: 'financeCommissionEdit', component: commissionForm, meta: { c: 'finance', a: 'commissionEdit' }
  },
];

export default financeRouter;
